import React from "react";
import PropTypes from "prop-types";
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Checkbox,
} from "@mui/material";
import { makeStyles } from 'tss-react/mui';
import useMediaQuery from "@mui/material/useMediaQuery";

export default function EnhancedTableHead(props) {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const useStyles = makeStyles()((theme) => ({
    root: {
      "& tr": {
        borderTop: `1px solid ${theme.palette.primary.hr}`,
      },
      "& th": {
        background: prefersDarkMode?theme.palette.primary.dark:"white",
        whiteSpace: "nowrap",
      },
      "& .MuiTableSortLabel-active, & .MuiTableSortLabel-root.MuiTableSortLabel-active.MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon": {
        color: theme.palette.primary.light,
      },
    },
  }));
  const { classes: style } = useStyles();
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    data,
    selectable,
    tab,
    dense
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead className={style.root}>
      <TableRow style={{ height: dense ? 33 : 62.2 }}>
        {typeof data !== "undefined" && selectable ? (
          <TableCell padding="checkbox" style={{ flexDirection: "row"}}>
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              slotProps={{
                input: { "aria-label": "select all desserts" }
              }}
            />
          </TableCell>
        ) : null}

        {data[tab].map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  data: PropTypes.shape({
    id: PropTypes.string,
    numeric: PropTypes.bool,
    disablePadding: PropTypes.bool,
    label: PropTypes.string,
  }),
  selectable: PropTypes.bool.isRequired
};